import PropTypes from 'prop-types';
import { createContext, useContext, useMemo } from 'react';

const DomainContext = createContext({
  domain: null,
  domainId: null,
  domainIdKey: null,
});

const DomainProvider = ({ children, domain, domainId }) => {
  const value = useMemo(
    () => ({ domain, domainId, domainIdKey: `${domain}Id` }),
    [domain, domainId]
  );

  return (
    <DomainContext.Provider value={value}>{children}</DomainContext.Provider>
  );
};

export const useDomain = () => useContext(DomainContext);

DomainProvider.propTypes = {
  domain: PropTypes.string.isRequired,
  domainId: PropTypes.number.isRequired,
};

export default DomainProvider;
